module.exports = {
  familyName: 'Open Sans',
  capHeight: 1462,
  ascent: 2189,
  descent: -600,
  lineGap: 0,
  unitsPerEm: 2048
};